import Vue from 'vue'
import env from '../../../config/prod.env.js'

const mutations = {
    API_FAILURE (state, payload) {
        throw {error: true, payload: payload.body}
    }
}

const actions = { 
    addCommentToProblem: (context, data) => {
        return Vue.http.post(`${env.API}/api/problem/comment`, data)
        .then(response => {
            return response.body.message
        })
        .catch(error => {
            return context.commit('API_FAILURE', error)
        })
    },
    getCommentsFromProblem: (context, id) => {
        return Vue.http.get(`${env.API}/api/problem/comments/${id}`)
        .then(response => {
            return response.body.message
        })
        .catch(error => {
            return context.commit('API_FAILURE', error)
        })
    },
    closeProblem: (context, data) => {
        const { id, accomplished, comment } = data
        return Vue.http.put(`${env.API}/api/problem/${id}`, { accomplished, comment})
        .then(response => {
            return response.body.message
        })
        .catch(error => {
            return context.commit('API_FAILURE', error)
        })        
    }
}

export const problem = {
    namespaced: true,
    actions,
    mutations
}


// WEBPACK FOOTER //
// ./src/store/modules/problem.js